import React from 'react';

const AgenticPlannerIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M11.2783 6.61914C11.581 6.04629 12.4169 6.04645 12.7197 6.61914L13.5645 8.21777C13.8658 8.7879 14.3431 9.25267 14.9297 9.5459L16.5732 10.3672C17.1615 10.6623 17.1625 11.4875 16.5732 11.7822L14.9297 12.6045C14.343 12.8978 13.8657 13.3633 13.5645 13.9336L12.7197 15.5312C12.417 16.1041 11.581 16.1041 11.2783 15.5312L10.4355 13.9336C10.1343 13.3634 9.65687 12.8978 9.07031 12.6045L7.42676 11.7822C6.83717 11.4876 6.83823 10.6623 7.42676 10.3672L9.07031 9.5459C9.65677 9.25264 10.1343 8.78784 10.4355 8.21777L11.2783 6.61914Z'
        fill='#000'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M15.4043 2C19.0419 2.00037 21.9998 4.87259 22 8.4248V22L16.9863 19.6768C16.3013 19.3594 15.531 19.2593 14.7842 19.3916L9.77539 20.2773C5.73244 20.9924 2.00034 17.9701 2 13.9561V8.4248C2.00016 4.87244 4.9579 2.00024 8.5957 2H15.4043ZM8.5957 3.80957C5.96972 3.80981 3.84781 5.88079 3.84766 8.4248V13.9561C3.848 16.8301 6.52656 19.0134 9.44629 18.4971L14.4541 17.6104C15.581 17.4111 16.7436 17.5623 17.7773 18.041L20.1504 19.1396V8.4248C20.1502 5.88072 18.0294 3.8097 15.4033 3.80957H8.5957Z'
        fill='#000'
      />
    </svg>
  );
};

export default AgenticPlannerIcon;
